import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { CommonService } from '../../../common-service';
import { ListDeviceTypeResponse } from '../../../responses/device/list-device-type.response';

@Injectable({
  providedIn: 'root'
})
export class DeviceTypeService extends CommonService{

  constructor(private router: Router,
private httpClient: HttpClient,
configService:AppConfigService,
private endpointBuilder: EndpointBuilderService) {
    super(configService);
  }

  public listAllDevices(): Observable<ListDeviceTypeResponse> {
    let uri = "DeviceType"

    return this.httpClient.get<ListDeviceTypeResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiDevice) + uri)
      .pipe(
        catchError(this.handleError)
    )
  }
}
